// extracted by mini-css-extract-plugin
export default {"control":"LanguagePicker_control__aglxR","label":"LanguagePicker_label__FKevX","icon":"LanguagePicker_icon__fmsCg"};